import { RedirectType, RoutePageRedirects } from '~/plugins/router/_types';

let _pageRedirects: RoutePageRedirects | null = null;

export const getPageRedirects = () => {
    if (_pageRedirects == null) {
        _pageRedirects = redirects();
    }
    return _pageRedirects;
};

const redirects = (): RoutePageRedirects => {
    const p = useAppPermissions();
    return {
        orders: () => (p.canShowOrders() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        demands: () => (p.canShowDemands() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'service-calls': () => (p.canShowServiceCalls() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        invoices: () => (p.canShowInvoices() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'delivery-lists': () => (p.canShowDeliveryLists() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        documents: () => (p.canShowDocuments() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-id': () => (p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'demands-id': () => (p.canShowDemands() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'documents-id': () => (p.canShowDocuments() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-thank-you': () =>
            p.canCreateOrder() || p.canSaveOrderDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-thank-you': () =>
            p.canCreateDemand() || p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-new': () => (p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-new-categories': () => (p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-new-categories-catid': () => (p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-new-categories-sale-catid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-new-categories-catid-items-itemid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-new-categories-sale-catid-items-itemid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-new-categories-catid-lines-lineid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-new-categories-sale-catid-lines-lineid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new': () => (p.canSaveOrderDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-id-new-categories': () => (p.canSaveOrderDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'orders-id-new-categories-catid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new-categories-sale-catid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new-categories-catid-items-itemid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new-categories-sale-catid-items-itemid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new-categories-catid-lines-lineid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'orders-id-new-categories-sale-catid-lines-lineid': () =>
            p.canCreateOrder() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories': () => (p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'demands-new-categories-catid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories-sale-catid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories-catid-items-itemid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories-sale-catid-items-itemid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories-catid-lines-lineid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-new-categories-sale-catid-lines-lineid': () =>
            p.canCreateDemand() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new': () => (p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'demands-id-new-categories': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-catid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-sale-catid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-catid-items-itemid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-sale-catid-items-itemid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-catid-lines-lineid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        'demands-id-new-categories-sale-catid-lines-lineid': () =>
            p.canSaveDemandDraft() ? RedirectType.NoRedirect : RedirectType.AccessDenied,
        admin: () => (p.canManageApp() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-documents': () => (p.canManageDocuments() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-documents-id': () => (p.canManageDocuments() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-partners': () => (p.canManagePartners() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-partners-id': () => (p.canManagePartners() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-translations': () => (p.canManageDials() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-users': () => (p.canManageUsers() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-users-id': () => (p.canManageUsers() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
        'admin-users-new': () => (p.canManageUsers() ? RedirectType.NoRedirect : RedirectType.AccessDenied),
    };
};
